import React  from 'react';
import PropTypes from 'prop-types';

import SelectProgress from "core/gd-ui/select-progress/common";
import ProgressAutoField from "../progress-auto";

export default function ProgressAutoInList(props) {
    return (
        <SelectProgress renderValue="bar-50"
                        className={props.className}
                        underlined="on-hover"
                        value={ProgressAutoField.getValue(props.item)}
                        attachment="center right"
                        targetAttachment="center left"
                        offset="0 0"
                        disabled={true}
                        onUserSelect={props.onProgressSelect}
                        deleteButton={false} />
    );
}

ProgressAutoInList.propTypes = {
    item: PropTypes.object,

    onProgressSelect: PropTypes.func
};